<template>
  <div>
    <h5 class="card-title">
      Automatické doplnění hodnot
    </h5>
    <div class="form-group form-check">
      <UISwitch v-model="enabled">
      </UISwitch>
    </div>
    <div v-if="value.enabled">
      <Multiselect
        v-model="defaultType"
        label="label"
        trackBy="id"
        valueByPath="id"
        :options="defaultTypeOptions"
        :max="1"
        :disabled="!value.enabled"
        :returnAsSingle="true"
      ></Multiselect>
      <div v-if="defaultType === 'default'">
        <Grid
          v-if="value.enabled"
          v-model="value.chunks"
          :cols="GRID_COLS"
          :options="{header: true}"
        >
        </Grid>
        <div class="form-info-text">
          <span class="badge badge-pill badge-warning">Datum a čas</span>
          Do výrazu zadejte formát v jakém se má přidat do hodnoty. Formát výrazu vychází z funkce
          <a href="https://www.programiz.com/python-programming/datetime/strftime">strftime</a>. Například pro kombinaci
          den-měsíc-rok zadejte <strong>%y-%m-%d</strong> a výsledek pro datum 11.9.2019 bude <strong>19-11-09</strong>
        </div>
        <div class="form-info-text">
          <span class="badge badge-pill badge-warning">Hodnota se sequence</span>
          Do výrazu zadejte délku na kterou se má vygenerované čislo doplnit nulami. <strong>Například</strong> zadáte li číslo čtyři a generátor vygeneruje třeba osm,
          výsledná hodnota bude 0008
        </div>
        <div class="form-info-text">
          <span class="badge badge-pill badge-warning">Konstanta</span>
          Do výrazu zadejte textový řetězec který bude doplněn do výsledné hodnoty bez jakékoliv změny.
        </div>
        <div class="form-info-text">
          <span class="badge badge-pill badge-warning">Zkratka projektu (Pracovní verze!)</span>
          Do výrazu zadejte dvě čísla oddělená čárkou přičemž první představuje počáteční pozici a druhé číslo délku řetězce který se vyřízne
          z názvu projektu. Název projektu se pře vyříznutím zbaví diakritiky a převede na velká písmena. <strong>Například</strong> výraz 0,3 pro název
          programování vyřizne PRO nebo výraz 3,1 vyrizne G
        </div>
      </div>
    </div>
    <div v-else
         class="alert alert-warning"
    >
      Automatické doplnění hodnot je vypnuto.
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import Grid from 'CORE/components/grid'
import Multiselect from 'CORE/components/utilities/vue-multiselect-ext'
import UISwitch from 'CORE/components/utilities/ui-switch'

const GRID_COLS = {
    type: {
        type: 'select',
        name: 'Type',
        required: true,
        options: { datetime: 'Datum a cas', sequence: 'Hodnota ze sequence', constant: 'Konstanta', project_abbreviation: 'Zkratka projektu' },
    },
    expression: {
        type: 'text',
        name: 'Vyraz',
        required: true,
    },
}

export default {
    name: 'DefaultValue',
    components: {
        Grid,
        Multiselect,
        UISwitch,
    },
    props: {
        value: {
            required: true,
            type: Object,
        },
    },
    data() {
        return {
            cols: {},
        }
    },
    computed: {
        GRID_COLS() {
            return GRID_COLS
        },
        defaultTypeOptions() {
            return [
                { id: 'default', label: 'Výchozí konfigurace' },
                { id: 'bohemiatel_cislo-stavby', label: 'BOHEMIATEL: Číslo zakázky' },
            ]
        },
        enabled: {
            get() {
                return this.value.enabled
            },
            async set(value) {
                try {
                    if (value === false) {
                        await this.$prompt('Vypnutím přijdete o veškerá nastavení v této záložce, chcete pokračovat?')
                    }
                    this.value.chunks = []
                    this.value.enabled = value
                } catch (e) {
                    this.value.enabled = true
                }
            },
        },
        defaultType: {
            get() {
                return this.value.type
            },
            set(value) {
                this.value.type = value
            },
        },
    },
}
</script>

<style scoped>
.form-info-text {
    color: silver;
    padding: 5px 5px 0px 20px;
}
.card-title {
    margin: 20px 0 5px 0;
    font-size: 1rem;
    text-align: center;
}
</style>

